import React, { useState, useEffect, FC } from 'react';
import Select from 'react-select';

import './SelectGroups.css';
import { useHttpClient } from '../../hooks/http-hook';
import { api } from '../../services/api';
import { useAppDispatch } from '../../services/store';

export interface Group {
  _id: string;
  name: string;
}

export interface SelectGroupsProps {
  onClose: () => void;
}

const SelectGroups: FC<SelectGroupsProps> = ({ onClose }) => {
  const { sendRequest } = useHttpClient();
  const [data, setData] = useState<Group[]>([]);
  const dispatch = useAppDispatch();
  const [selectedRow, setSelectedRow] = useState<any>({});

  const handleSelect = (e: any) => {
    setSelectedRow(e);
  };

  const handleGetGroups = async () => {
    try {
      const responseData = await sendRequest(
        `${import.meta.env.VITE_BACKEND_URL}/api/users/getGroups`,
        'GET',
        null,
        {}
      );
      setData(
        responseData.groups?.map((group: Group) => ({
          value: group._id,
          label: group.name
        }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleSaveGroup = async () => {
    try {
      await sendRequest(
        `${import.meta.env.VITE_BACKEND_URL}/api/users/changeGroup`,
        'POST',
        JSON.stringify({
          groupId: selectedRow.value
        }),
        {
          'Content-Type': 'application/json'
        }
      ).then(() => {
        //relogin for get the new token with group.
        dispatch(api.endpoints.relogin.initiate()).refetch();
        onClose();
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(
    () => {
      setSelectedRow({});
      handleGetGroups();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className="select-groups_container">
      <div className="run-test-header">
        <div
          style={{
            flex: 1,
            padding: '24px 30px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          Change work Group
        </div>
      </div>
      <hr />
      <div className="select-groups">
        <Select
          menuPosition={'fixed'}
          isSearchable={false}
          placeholder="Select work group"
          options={data}
          styles={{
            ...customStyles,
            control: (base) => ({
              ...base,
              height: 60,
              minHeight: 60,
              borderRadius: 7
            })
          }}
          onChange={handleSelect}
        />
      </div>
      <div className="run-test-buttons-section">
        <button id="cancel" onClick={() => onClose()}>
          Cancel
        </button>
        <button
          id="start"
          onClick={() => handleSaveGroup()}
          disabled={!selectedRow?.value}
          style={{
            opacity: !selectedRow?.value ? '0.1' : '1',
            cursor: !selectedRow?.value ? 'unset' : 'pointer'
          }}
        >
          {' '}
          Change
        </button>
      </div>
    </div>
  );
};

const customStyles = {
  control: (base: any) => ({
    ...base,
    height: 60,
    minHeight: 60
  })
};

export default SelectGroups;
